import * as Yup from 'yup';
import { addDays } from '../../../../../global/helpers/form-data-helper';
import { getRequiredText } from '../../../../../global/helpers/transformer';
import { YesNoIndicators } from '../../../../../global/models/api-model';
import { LabelSettingProps } from '../../../../../global/models/epi-model';
import { CompensationProps } from '../../../models/arc-epi-props';

export interface ScheduledHoursFormValues {
	start_date: string;
	hours: number | string;
	changeDueToIllness: string;
	extenuatingCircumstances: string;
	acknowledge: boolean;
}

export const ScheduledHoursValidationSchema = (compensationProps: CompensationProps, labelSettings: LabelSettingProps, isEdit: boolean, currentRecordCompareDate: string) => {
	return Yup.object().shape({
		start_date: isEdit ? undefined : Yup.date().nullable().required(getRequiredText(labelSettings.requiredFormat, compensationProps.scheduledHoursStartDateLabel))
			.min(addDays(currentRecordCompareDate, 1), compensationProps?.startDateAfterCurrentScheduledHoursDate || 'Start date must be after current record start and end date'),
		hours: Yup.number().positive(labelSettings.numberPositive),
		changeDueToIllness: Yup.string().ensure()
			.when(['hours'], {
				is: (hours) => {
					return hours < 1000;
				},
				then: Yup.string().required(getRequiredText(labelSettings.requiredFormat, compensationProps.illnessLabel)),
			}),
		acknowledge: Yup.boolean().when(['changeDueToIllness', 'hours'], {
				is: (changeDueToIllness, hours) => {
					return hours < 1000 && changeDueToIllness === YesNoIndicators.Yes;
				},
				then: Yup.boolean().required(compensationProps.acknowlegeIllnessRequiredText).oneOf([true], compensationProps.acknowlegeIllnessRequiredText),
			}),
		// commenting this requirement in case we need it again
		//.test('hours', labelSettings.numberFourDigits || 'Number must be 4 digits', (val) => {
		//return val?.toString().length === 4;
	});
};